import Button from "../components/flareEffect";

const NotFound = () => {
  return (
       <div className="flex flex-col items-center justify-center h-screen text-center">
      <h1 className="text-6xl font-bold text-yellow-500">404</h1>
      <p className="mt-4 text-xl">Oops! Page not found 🚧</p>
      <a href="/" className="mt-6 text-blue-400 hover:underline">
        Go back Home
      </a>
      <Button/>
    </div>
  );
};

export default NotFound;
